import React, { useState } from 'react';
import { useTodoStore } from '../../stores/useUIStore';

const RequestTaskClosureModal = ({ onClose, modalData }) => {
  const updateTaskStatus = useTodoStore((state) => state.updateTaskStatus);
  const [solution, setSolution] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const taskId = modalData?.taskId;

  if (!taskId) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!solution.trim()) {
      alert('Por favor, describe la solución implementada.');
      return;
    }
    setIsLoading(true);
    await updateTaskStatus(taskId, 'pending_closure', solution);
    setIsLoading(false);
    onClose();
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-xl w-full max-w-md">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Resolver y Solicitar Cierre</h2>
      <p className="mb-4 text-gray-600">
        Tarea ID: <span className="font-mono bg-gray-100 p-1 rounded">{taskId}</span>
      </p>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="solution" className="block text-sm font-medium text-gray-700 mb-2">
            Describe la solución
          </label>
          <textarea
            id="solution"
            rows="5"
            value={solution}
            onChange={(e) => setSolution(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder="Ej: Se contactó al usuario y se restableció su contraseña manualmente..."
            required
          ></textarea>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Enviar para Validación'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RequestTaskClosureModal;
